import { render } from "./CampagnaIntegrazioneFc3.vue?vue&type=template&id=71e17042&scoped=true"
import script from "./CampagnaIntegrazioneFc3.vue?vue&type=script&lang=js"
export * from "./CampagnaIntegrazioneFc3.vue?vue&type=script&lang=js"

import "./CampagnaIntegrazioneFc3.vue?vue&type=style&index=0&id=71e17042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e17042"]])

export default __exports__